export default __webpack_public_path__ + "static/media/total_production_icon.b5c3bbc4.png";